module.exports = __webpack_public_path__ + "img/specschol.56efa68c.jpg";